import React, { useContext, useEffect, useState } from "react";
import { MdEdit } from "react-icons/md";
import { MdRemove } from "react-icons/md";
import Modal from "react-modal";
import Equipment from "./Equipment";
import { FaTimes } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import EquipmentImageWithLoader from "./EquipmentImageWithLoader";
import { EquipmentContext } from "../useContext/context";

function LineItem(props) {
    const {
        id,
        name,
        price,
        quantity,
        tag,
        apply_tpp,
        equipment,
        equipments,
        addQuantity,
        removeQuantity,
        updateEquipment,
        removeEquipment,
        allEquipments,
        action,
    } = props;
    const [edit_modal, setEditModal] = useState(false);
    const [selected_eqp, setSelectedEqp] = useState(equipment);
    const { setIsDeviceExpanded } = useContext(EquipmentContext);

    useEffect(() => {
        setSelectedEqp(equipment);
    }, [equipment]);

    const handleInputChange = (name, value) => {
        setSelectedEqp((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleTypeCheck = (event, type) => {
        event.persist();
        setSelectedEqp((prevState) => ({
            ...prevState,
            type,
        }));
    };

    const editEquipment = (_e) => {
        updateEquipment(selected_eqp);
        setEditModal(false);
    };

    const renderQuantity = () => {
        return (
            <div className={`quantity-container qty-active`}>
                <button
                    className="qty-button"
                    type="button"
                    onClick={() => removeQuantity(equipment)}
                >
                    <FaMinus />
                </button>
                <span>{equipments.length}</span>
                <button
                    className="qty-button"
                    type="button"
                    onClick={() => addQuantity(equipment)}
                >
                    <FaPlus />
                </button>
            </div>
        );
    };

    const renderActionBtn = () => {
        return (
            <button className="primary-btn" onClick={editEquipment}>
                Update
            </button>
        );
    };

    return (
        <div className="cost-item">
            <div className="img-c">
                <span className="qty-counter">{quantity}</span>
                <EquipmentImageWithLoader id={id} size="small" />
                {action && (
                    <>
                        <span
                            className="edit-line-item"
                            onClick={() => {
                                setEditModal(true);
                                setIsDeviceExpanded(false);
                            }}
                        >
                            <MdEdit />
                        </span>
                        <span
                            className="remove-line-item"
                            onClick={() => removeEquipment()}
                        >
                            <MdRemove />
                        </span>
                    </>
                )}
            </div>
            <span className="text">
                {name}
                {tag && <span className="cost-type-badge">{tag}</span>}
            </span>
            <span className="dots"></span>
            {apply_tpp ? (
                <div className="tpp-amount">
                    <s>
                        <span className="amount" style={{ width: "100%" }}>
                            $ {new Number(parseFloat(price)).toFixed(2)}
                        </span>
                    </s>
                    <span className="amount" style={{ width: "100%" }}>
                        $ {"0.00"}
                    </span>
                </div>
            ) : (
                <span className="amount">
                    $ {new Number(parseFloat(price)).toFixed(2)}
                </span>
            )}

            <Modal
                isOpen={edit_modal}
                className="ems-boot-modal edit-eqp-modal"
            >
                <button
                    className="close-modal-btn"
                    onClick={() => setEditModal(false)}
                    type="button"
                >
                    <FaTimes />
                </button>
                <div>
                    <div className="equipment-box">
                        <p className="box-label">Edit Equipment</p>
                        <div className="eqp-row">
                            <Equipment
                                key={equipment.id}
                                equipment={selected_eqp}
                                handleInputChange={handleInputChange}
                                handleTypeCheck={handleTypeCheck}
                                allEquipments={allEquipments}
                                renderQuantity={renderQuantity}
                                renderActionBtn={renderActionBtn}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default LineItem;
